module.exports = __webpack_public_path__ + "media/brand/popularLabel-8e11b0d3.svg";